import Palette from './Palette.container';

export default Palette;
